<section class="rcx-table">
    <div class="row">
        <div class="col-lg-12">
            <div class="card btr">
                <div class="card-content">
                    <div class="card-body table-responsive">
                        <div class="row d-flex align-items-center">
                            <div class="col-lg-auto">
                                <h5 class="card-title m-0">
                                    <i class="ri-secure-payment-line font-20 text-primary"></i>
                                    Payments
                                </h5>
                            </div>
                            <div class="col-sm-12 col-md-5 col-lg-2 ps-1">
                                <div class="input-group">
                                    <span class="input-group-text bg-primary" id="search" ngbTooltip="Filter by Status."
                                        placement="top" container="body">
                                        <i class="bx bx-filter"></i>
                                    </span>
                                    <select class="form-select" autocomplete="off" id="status"
                                        [(ngModel)]="selectedFrequency">
                                        <option hidden value=null disabled selected>Choose...
                                        </option>
                                        <option *ngFor="let frequency of frequencies;let i=index" [ngValue]="frequency">
                                            {{frequency}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-auto">
                                <div class="input-group">
                                    <span class="input-group-text bg-primary" id="fromDateTooltip"
                                        ngbTooltip="Filter by From date." placement="top" container="body">
                                        <i class="bx bx-calendar-week"></i>
                                    </span>
                                    <input type="date" class="form-control border-start-0" placeholder="From date..."
                                        [(ngModel)]="fromDate" autocomplete="off">
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-2 me-auto ps-1">
                                <div class="input-group">
                                    <button type="button" ngbTooltip="Fetch Records." placement="top" container="body"
                                        (click)="onStatusChange()" class=" btn btn-secondary btn-sm ">
                                        <i class="bx bx-search-alt-2 ri-lg align-middle me-0"></i>
                                    </button>
                                    <button type="button" ngbTooltip="Download as Excel" placement="top"
                                        container="body" class="btn btn-success btn-sm ms-2"
                                        (click)="downloadExcel()">
                                        <i class="bx bx-download ri-lg align-middle me-0"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <table class="table" id="table">
                            <thead id="table-thead">
                                <tr class="bg-light">
                                    <th scope="col" width="70">#</th>
                                    <th scope="col" width="300">Employee Name</th>
                                    <th scope="col" width="300">Date</th>
                                    <th scope="col" width="300">Frequency</th>
                                    <th scope="col" width="300">PF</th>
                                    <th scope="col" width="300" class="text-center">Basic Salary</th>
                                    <th scope="col" width="300" class="text-center">Net Salary</th>
                                    <th scope="col" width="300" class="text-center">Status</th>
                                    <th scope="col" width="160" class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let salary of salaries | search : 'name' : searchKeyword; let i=index">
                                    <td>{{i+1}}.</td>
                                    <td>{{salary.employeeName}}</td>
                                    <td>{{ salary.fromDate | date:'dd/MM/yyyy' }}</td>
                                    <td>{{salary.frequency}}</td>
                                    <td>{{salary.providentFund}}</td>
                                    <td class="text-center">{{salary.basicSalary}}</td>
                                    <td class="text-center">{{salary.netSalary}}</td>
                                    <td class="text-center">{{salary.status}}</td>
                                    <td class="action text-center">
                                        <button data-bs-toggle="modal" class="btn btn-secondary btn-sm me-2"
                                            [ngClass]="{'no-event':salary?.isDeleteInProgress,'not-allowed':!privilege.canEdit}"
                                            [ngbTooltip]="!privilege.canEdit? 'You need permissions for this action. Required permission(s): payroll.Payment.Add' : ''"
                                            *ngIf="salary?.status === 'NIL' || salary?.status === 'DUE' || salary?.status === 'PAY' || salary?.status === 'CREATE'"
                                            data-bs-target="#salaryModal"
                                            (click)="salary?.status === 'NIL' ? upsertDue(salary) : (salary?.status === 'DUE' ? upsertPayment(salary) : upsertSalary(salary))">
                                            <i class='bx bx-credit-card align-middle me-0'></i>
                                            {{ salary?.status === 'NIL' ? 'Due' : (salary?.status === 'DUE' ? 'Pay' :
                                            (salary?.status === 'PAY' ? 'Done' : 'Salary')) }}
                                        </button>
                                    </td>
                                </tr>
                                <tr class="no-data">
                                    <ng-container *ngIf="isLoading; else noDataTemplate">
                                        <td colspan="7">Fetching data, please wait...</td>
                                    </ng-container>
                                    <ng-template #noDataTemplate>
                                        <ng-container *ngIf="salaries && salaries.length < 1; else noSearchResults">
                                            <td colspan="7">No payments were found.</td>
                                        </ng-container>
                                        <ng-template #noSearchResults>
                                            <td colspan="7"
                                                *ngIf="searchKeyword && (salaries | search : 'name' : searchKeyword).length == 0">
                                                No payments were found for the search results.
                                            </td>
                                        </ng-template>
                                    </ng-template>
                                </tr>
                            </tbody>
                        </table>
                        <div class="row mt-2">
                            <div class="col-md-6">
                                <h6 class="text-danger">Total Due: ₹{{ totalDue | number }}</h6>
                            </div>
                            <div class="col-md-6">
                                <h6 class="text-success">Total Paid: ₹{{ totalPaid | number }}</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>